import { QueryClient } from '@tanstack/react-query';

const QUERY = new QueryClient();

export default QUERY;
